import { Base } from "ui/Scripts/source/framework/base";
import { IPagePanel } from "../common/pagePanel";
import { CompanyMenuItem, ICompanyMenuItem } from "ui/Scripts/source/models/company/companyMenuItem";
import { ISavedListFilter, SavedListFilter } from "../common/savedListFilter";
import { AppReportPageData, IAppReportPageData } from "./appReportPageData";
import { AppReportPagePanel } from "./appReportPagePanel";

export interface IAppReportPage extends IAppReportPageData {
    panels: IPagePanel[];
    companies: ICompanyMenuItem[];
    companyFilters: ISavedListFilter[];
    userFilters: ISavedListFilter[];
    showDocumentPreview: boolean;
}

export class AppReportPage extends AppReportPageData implements IAppReportPage {
    panels: AppReportPagePanel[];
    companies: CompanyMenuItem[];
    companyFilters: SavedListFilter[];
    userFilters: SavedListFilter[];
    showDocumentPreview: boolean;

    constructor();
    constructor(obj: IAppReportPage);
    constructor(obj?: any) {
        super(obj);
        this.panels = Base.getTypedArray(obj ? obj.panels : null, AppReportPagePanel);
        this.companies = Base.getTypedArray(obj ? obj.companies : null, CompanyMenuItem);
        this.companyFilters = Base.getTypedArray(obj ? obj.companyFilters : null, SavedListFilter);
        this.userFilters = Base.getTypedArray(obj ? obj.userFilters : null, SavedListFilter);
        this.showDocumentPreview = obj && obj.showDocumentPreview || false;
    }
}
